import { ThemeProps } from '@theme/base';
import { withTheme } from '@emotion/react';
import styled from '@emotion/styled';

interface TitleContainerProps extends ThemeProps {
  title: string;
}

const Container = styled.div({
  background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 75%)',
  position: 'absolute',
  height: '100%',
  left: 0,
  paddingBottom: 50,
  top: 0,
  width: '100%',
  '> div': {
    position: 'absolute',
    bottom: 50,
    width: '100%'
  }
});

const Title = styled.h1(({ theme }: ThemeProps) => ({
  color: theme.custom.colors.white,
  lineHeight: 'normal',
  margin: '0 auto',
  maxWidth: theme.custom.contentSizes.maxContentWidth,
  padding: `0 ${theme.custom.spacing.large}px`,
  textShadow: `rgb(25, 25, 25) 0px 0px 6px`
}));

export const TitleContainerComponent = ({ title }: TitleContainerProps) => {
  return (
    <Container>
      <div>
        <Title>{title}</Title>
      </div>
    </Container>
  );
};

export const TitleContainer = withTheme(TitleContainerComponent);
